<div class="login-container">
  <img src="assets/img/kam.jpeg" alt="Kangaroo Logo" class="login-logo" />
  <div class="login-card">
    <div class="login-header">
      <h1>Login to our portal</h1>
      <p>Sign in to your account</p>
    </div>
    <div class="login-body">
      <form [formGroup]="loginForm" (ngSubmit)="goLogin()">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="icon-user"></i>
              </span>
            </div>
            <input
              (keydown.space)="$event.preventDefault()"
              class="form-control"
              autocomplete="off"
              placeholder="Email address"
              formControlName="email"
              type="email"
              [(ngModel)]="model.email"
              [ngClass]="{ 'is-invalid': submitted && lf.email.errors }"
            />
            <div
              *ngIf="submitted && lf.email.errors"
              class="invalid-feedback"
            >
              <div *ngIf="lf.email.errors.required">
                Please enter email.
              </div>
              <div *ngIf="lf.email.errors.pattern">
                Please enter valid email.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="icon-lock"></i>
              </span>
            </div>
            <input
              id="password1"
              class="form-control"
              type="password"
              autocomplete="off"
              placeholder="Password"
              formControlName="password"
              [(ngModel)]="model.password"
              [ngClass]="{
                'is-invalid': submitted && lf.password.errors
              }"
            />
            <div
              *ngIf="submitted && lf.password.errors"
              class="invalid-feedback"
            >
              <div
                *ngIf="
                  lf.password.errors.required ||
                  lf.password.errors.whiteSpace
                "
              >
                Please enter password.
              </div>
              <div *ngIf="lf.password.errors.minlength">
                Password length must be at least 5 characters long.
              </div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          class="login-button"
        >
          Sign In
        </button>

        <div class="forgot-password">
          <p>
            If you cannot remember your password, you can
            <a href="#">Reset your password</a> on AU Login.
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
